import React from 'react';
import PropTypes from 'prop-types';

import StepTitle from '../StepTitle';
import ShippingForm from './components/ShippingForm';
import AddressValidationModal from './components/AddressValidationModal';

const Shipping = props => (
  <>
    <AddressValidationModal
      isOpen={props.showShippingSuggestionModal}
      onClose={props.closeShippingSuggestionModal}
      shippingState={props.shipping}
      suggestion={props.shippingAddressSuggestion}
      handleKeepOriginal={props.submitShippingForm}
      handleSelectRecommended={props.handleSelectRecommendedShipping}
    />

    <StepTitle number="2">Shipping Information</StepTitle>

    <ShippingForm
      shipping={props.shipping}
      onSubmit={props.validateShippingAddress}
      updateShipping={props.updateShipping}
      disableSubmitBtn={props.disableSubmitBtn}
      validateFormOnLoad={props.validateFormOnLoad}
      isTradeUser={props.isTradeUser}
    />
  </>
);

Shipping.propTypes = {
  disableSubmitBtn: PropTypes.bool,
  shipping: PropTypes.object,
  submitShippingForm: PropTypes.func.isRequired,
  updateShipping: PropTypes.func.isRequired,
  validateFormOnLoad: PropTypes.bool,
  isTradeUser: PropTypes.bool,
  showShippingSuggestionModal: PropTypes.bool,
  closeShippingSuggestionModal: PropTypes.func,
  validateShippingAddress: PropTypes.func,
  handleSelectRecommendedShipping: PropTypes.func,
  shippingAddressSuggestion: PropTypes.object,
};

export default Shipping;
